import { combineReducers, AnyAction, Reducer } from 'redux';
import actionModalReducer from './Components/ActionModal/actionModalSlice';
import actionViewerReducer from './Components/ActionViewer/actionViewerSlice';
import apiResponseModalReducer from './Components/ApiResponseModal/apiResponseModalSlice';
import appReducer from './Components/App/appSlice';
import brandModalReducer from './Components/BrandModal/brandModalSlice';
import brandViewerReducer from './Components/BrandViewer/brandViewerSlice';
import conditionDetailEditorReducer from './Components/ConditionDetailEditor/conditionDetailEditorSlice';
import layoutCategoryFieldModalReducer from './Components/LayoutCategoryFieldModal/layoutCategoryFieldModalSlice';
import layoutCategoryModalReducer from './Components/LayoutCategoryModal/layoutCategoryModalSlice';
import layoutViewerReducer from './Components/LayoutViewer/layoutViewerSlice';
import pickAFileReducer from './Components/PickAFile/pickAFileSlice';
import questionModalReducer from './Components/QuestionModal/questionModalSlice';
import questionOptionsModalReducer from './Components/QuestionOptionsModal/questionOptionsModalSlice';
import questionServiceQuestionBrandModalReducer from './Components/QuestionServiceQuestionBrandModal/QuestionServiceQuestionBrandModalSlice';
import questionViewerReducer from './Components/QuestionViewer/questionViewerSlice';
import refreshLoadedFileReducer from './Components/RefreshLoadedFile/refreshLoadedFileSlice';
import ruleModalReducer from './Components/RuleModal/ruleModalSlice';
import ruleViewerReducer from './Components/RuleViewer/ruleViewerSlice';
import selectFileReducer from './Components/SelectFile/selectFileSlice';
import serviceModalReducer from './Components/ServiceModal/serviceModalSlice';
import serviceQuestionBrandModalReducer from './Components/ServiceQuestionBrandModal/serviceQuestionBrandModalSlice';
import serviceQuestionModalReducer from './Components/ServiceQuestionModal/serviceQuestionModalSlice';
import serviceQuestionViewerReducer from './Components/ServiceQuestionViewer/serviceQuestionViewerSlice';
import serviceViewerReducer from './Components/ServiceViewer/serviceViewerSlice';
import StandardQuestionReducer from './Components/StandardQuestions/StandardQuestionsSlice';
import uploadFileReducer from './Components/UploadFile/uploadFileSlice';
import { reducerDispatch } from "./Constants/ReduxConstants";

const allReducers = combineReducers({
    // Everything in state will be organized under the reducer.
    // For example to access the questions from pickAFileReducer we would need to use (state => state.pickAFile.{action field you want to access})
    pickAFile: pickAFileReducer,
    refreshLoadedFile: refreshLoadedFileReducer,
    layoutViewer: layoutViewerReducer,
    app: appReducer,
    actionModal: actionModalReducer,
    brandModal: brandModalReducer,
    layoutCategoryFieldModal: layoutCategoryFieldModalReducer,
    layoutCategoryModal: layoutCategoryModalReducer,
    questionModal: questionModalReducer,
    questionOptionsModal: questionOptionsModalReducer,
    ruleModal: ruleModalReducer,
    serviceModal: serviceModalReducer,
    serviceQuestionBrandModal: serviceQuestionBrandModalReducer,
    serviceQuestionModal: serviceQuestionModalReducer,
    serviceQuestionViewer: serviceQuestionViewerReducer,
    conditionDetailEditor: conditionDetailEditorReducer,
    questionViewer: questionViewerReducer,
    brandViewer: brandViewerReducer,
    questionServiceQuestionBrandModal: questionServiceQuestionBrandModalReducer,
    actionViewer: actionViewerReducer,
    ruleViewer: ruleViewerReducer,
    uploadFile: uploadFileReducer,
    apiResponseModal: apiResponseModalReducer,
    selectFile: selectFileReducer,
    serviceViewer: serviceViewerReducer,
    standardQuestionViewer: StandardQuestionReducer
});

export type RootState = ReturnType<typeof allReducers>;

const rootReducer: Reducer<RootState | undefined, AnyAction> = (state, action) => {
    if (action.type === reducerDispatch.resetState) {
        state = undefined;
    }

    return allReducers(state, action);
};

export default rootReducer;
